import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextarea,{staticClass:"g-field",attrs:{"label":"Collection instruction","outlined":"","dense":"","rows":"4","loading":_vm.loading,"disabled":_vm.disabled},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"fieldValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }